/**
 * API configuration: base URL (proxy server), endpoint paths, timeouts.
 * Credentials are handled by the proxy; do not expose WooCommerce keys in the frontend.
 */

// Backend API (Spring Boot); default port 8080 with context-path /api
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

export const API_CONFIG = {
  BASE_URL: BASE_URL.replace(/\/$/, ''),
  TIMEOUT_MS: 30000,
  ENDPOINTS: {
    AUTH_LOGIN: '/auth/login',
    AUTH_ME: '/auth/me',
    ORDERS: '/orders',
    ORDER: (id) => `/orders/${id}`,
    CUSTOMERS: '/customers',
    CUSTOMER: (id) => `/customers/${id}`,
    PRODUCTS: '/products',
    PRODUCT: (id) => `/products/${id}`,
    PRODUCT_STOCK: (id) => `/products/${id}/stock`,
    STOCK_DASHBOARD: '/stock-dashboard',
    STOCK_AUDIT: '/stock-audit',
    LOCAL_ORDERS: '/local-orders',
    LOCAL_ORDER: (id) => `/local-orders/${id}`,
    LOCAL_ORDER_STATUS: (id) => `/local-orders/${id}/status`,
    PURCHASE_ORDERS: '/purchase-orders',
    PURCHASE_ORDER: (id) => `/purchase-orders/${id}`,
    ORDER_REFUND: (id) => `/orders/${id}/refunds`,
    ORDER_REFUND_STOCK_ONLY: (id) => `/orders/${id}/refunds/stock-only`,
    USERS: '/users',
    USER: (id) => `/users/${id}`,
    COUPONS: '/coupons',
    COUPON: (id) => `/coupons/${id}`,
    // Reports (WooCommerce Analytics-style if available)
    REPORTS_ORDERS: '/reports/orders',
    REPORTS_SALES: '/reports/sales',
    // Custom or WP REST if you add them
    DASHBOARD_STATS: '/dashboard/stats',
    COLOR_MAPPINGS: '/color-mappings',
    COLOR_MAPPING: (colorName) => `/color-mappings/${colorName}`,
    STOCK_PREFERENCES: '/stock-preferences',
    STOCK_PREFERENCE: (key) => `/stock-preferences/${key}`,
    STOCK_PREFERENCE_TABLE_COLOR: '/stock-preferences/table-header-color',
    STOCK_PREFERENCE_PRODUCT_TABLE_COLOR: (productId) => `/stock-preferences/table-header-color/${productId}`,
    STOCK_PREFERENCE_CATEGORY_ORDER: '/stock-preferences/category-order',
    STOCK_PREFERENCE_HIDDEN_PRODUCTS: '/stock-preferences/hidden-products',
  },
};

export default API_CONFIG;
